// External dependencies
import { createStore } from 'redux';

// internal imports
import rootReducer from './reducers';
import Middleware from './middleware';

 function initStore() {
    const store = createStore(rootReducer, Middleware);

	return { store };
}

// Configure redux store
export const { store } = initStore();
